import { AppDispatch } from "../../state-management/store";
import FormUtils from "./Form.utils";
import {
  BlobServiceClient,
  BlockBlobUploadResponse,
} from "@azure/storage-blob";
import {
  setImageDataUrl,
  setFileData,
  setImageProcessing,
} from "../../state-management/slices/outages/outages.slice";
import heic2any from "heic2any";
import imageCompression from "browser-image-compression";
import { isNullOrUndefined } from "../../shared/utils/data.utils";

/**
 * ImageUploadService
 * @export
 * @class ImageUploadService
 */
export class ImageUploadService {
  private static instance: ImageUploadService;
  private dispatch: AppDispatch;

  /**
   * Creates an instance of ImageUploadService.
   * @param {AppDispatch} dispatch
   * @memberof ImageUploadService
   */
  private constructor(dispatch: AppDispatch) {
    this.dispatch = dispatch;
  }

  /**
   * @static getInstance
   * @param {AppDispatch} dispatch
   * @return {*}  {ImageUploadService}
   * @memberof ImageUploadService
   */
  public static getInstance(dispatch: AppDispatch): ImageUploadService {
    if (!ImageUploadService.instance) {
      ImageUploadService.instance = new ImageUploadService(dispatch);
    }
    return ImageUploadService.instance;
  }

  /**
   * processImageUpload
   * @param {React.ChangeEvent<any>} uploadEvent
   * @memberof ImageUploadService
   */
  public processImageUpload(uploadEvent: React.ChangeEvent<any>): void {
    const reader = new FileReader();
    const file = uploadEvent.target.files[0];
    const imageUploadService = ImageUploadService.getInstance(this.dispatch);

    this.dispatch(setImageProcessing(true));

    reader.onload = async function (
      this: FileReader,
      ev: ProgressEvent<FileReader>
    ): Promise<any> {
      if (this.result) {
        let blob: Blob = FormUtils.getBlobFromDataURI(this.result as string);
        let compressedFile;

        // If the file is of .heic, we convert it to a .jpg
        if (file.name.endsWith(".heic")) {
          blob = (await heic2any({
            blob,
            toType: "image/jpeg",
          }).then((value) => {
            return value;
          })) as Blob;
        }

        try {
          compressedFile = await imageCompression(file, {
            maxSizeMB: 4,
            fileType: "image/jpeg",
          }).then((result: File) => {
            return Promise.resolve(result);
          });
        } catch (error) {
          console.log(error);
        }

        if (!isNullOrUndefined(compressedFile)) {
          const payload = {
            lastModified: compressedFile.lastModified,
            name: compressedFile.name,
            size: compressedFile.size,
            type: compressedFile.type,
          };

          FormUtils.getDataUriFromBlob(
            compressedFile,
            (dataUrl: string | ArrayBuffer | null | undefined) => {
              imageUploadService.dispatch(setImageDataUrl(dataUrl));
              imageUploadService.dispatch(setFileData(payload));
              imageUploadService.dispatch(setImageProcessing(false));
            }
          );
        }
      }
    };

    reader.readAsDataURL(uploadEvent.target.files[0]);
  }
}
